export const config = {
    threeUrl: "http://47.99.177.252:5505/3D/public/level/",
    // threeUrl: "http://localhost:5501/public/level/",
    // threeUrl: "http://192.168.33.198:5501/public/level/",

    gisUrl: "http://47.99.177.252:8182/Apps/Sandcastle/gallery/",
    // gisUrl: "http://localhost:5503/Apps/Sandcastle/gallery/",
    // gisUrl: "http://192.168.33.198:5503/Apps/Sandcastle/gallery/",
}